

import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import OnDeleteConfirm from "components/modals/OnDeleteConfirm";
import SettingService from "api/services/SettingService";
import AddFaq from './AddFaq'
import BackButton from "components/actions/BackButton";
import PageWrapper from "components/wrappers/PageWrapper";
import DashboardWrapper from "components/wrappers/DashboardWrapper";
import EditFaq from "./EditFaq";
import TableContainer from "components/TableContainer";
import FaqDetails from "./FaqDetails";
import { getLanguage } from "utils/Utils";
import ToastAlert from "components/ToastAlert";
import PropTypes from 'prop-types';

function FaqQuestionCell({ value, column }) {
    return <div className="flex-1 text-sm">{value[column.languageKey]}</div>;
}
function FaqActionsCell({ data, row, column }) {
    const id = data[row.id]?._id;
    const faqs = data[row.id];
    return (
        <div className="flex justify-end">
            <EditFaq key={"e3-12"} onUpdate={(newData) => column.onUpdate(id, column.categoryId, newData)} data={faqs} />
            <OnDeleteConfirm onConfirm={() => column.onDelete(id, column.categoryId)} key={"d3-1"} />
            <FaqDetails data={faqs} />
        </div>
    );
}

FaqQuestionCell.propTypes = {
    value: PropTypes.object,
    column: PropTypes.shape({ languageKey: PropTypes.string }),
};
FaqActionsCell.propTypes = {
    data: PropTypes.array,
    row: PropTypes.shape({ id: PropTypes.string }),
    column: PropTypes.shape({ onUpdate: PropTypes.func, onDelete: PropTypes.func, categoryId: PropTypes.string }),
};

const FaqList = () => {
    const { id: category_id } = useParams();
    const { t, i18n } = useTranslation();
    const history = useHistory()
    const [updateFAQStatus, setUpdateFAQStatus] = useState(null)
    const [addFAQStatus, setAddFAQStatus] = useState(null)
    const [deleteFAQStatus, setDeleteFAQStatus] = useState(null)

    const [remoteData, setRemoteData] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const cachedData = useMemo(() => (remoteData?.faqs), [remoteData?.faqs]);

    const onDelete = (id, category_id) => {
        SettingService.deleteFaq(id, category_id).then((resp) => {
            setDeleteFAQStatus("success");
            history.go();
        }).catch((err) => {
            //Handle error ..
            setDeleteFAQStatus("error");
        });
    }

    const onCreate = (data) => {

        SettingService.createFaq(category_id, data).then((resp) => {
            setAddFAQStatus("success");
            history.go();
        }).catch((err) => {
            //Handle error ..
            setAddFAQStatus("error");
        });
    }

    const onUpdate = (id, category_id, data) => {
        SettingService.updateFaq(id, category_id, data).then((resp) => {
            setUpdateFAQStatus("success");
            history.go();
        }).catch((err) => {
            //Handle error ..
            setUpdateFAQStatus("error");
        });
    }

    const columns = useMemo(

        () => [
            // {
            //     Header: () => null,
            //     id: t('form.id'), // 'id' is required
            //     accessor: '_id'
            // },
            {
                Header: t('form.faq'),
                accessor: "question",
                disableFilters: true,
                languageKey: getLanguage(i18n.language),
                Cell: FaqQuestionCell,
            },
            {
                Header: "",
                disableSortBy: true,
                accessor: "actions",
                onUpdate,
                onDelete,
                categoryId: category_id,
                Cell: FaqActionsCell,
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ], [t]
    );

    useEffect(() => {
        SettingService.getFaqList(category_id).then((resp) => {
            setRemoteData(resp)
            setLoading(false)
        }).catch((err) => {
            //Handle error ..
            setLoading(false)
            setError(err.message)
            history.push('/settings/faqs')
        });
        setAddFAQStatus(null); setDeleteFAQStatus(null); setUpdateFAQStatus(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category_id]);

    return (

        <DashboardWrapper>



            <PageWrapper
                title={<div className='flex space-x-2'>
                    <BackButton />
                    <div className="mr-8"> {remoteData?.title[getLanguage(i18n.language)]}  </div>
                </div>}
                actions={<AddFaq onCreate={onCreate} />}
            >
                <div className="mt-4">
                    <PageWrapper error={error} loading={loading} >
                        <TableContainer data={Array.isArray(cachedData) ? cachedData : []} columns={columns} globalSearch={true} />
                    </PageWrapper>
                </div>

                {(addFAQStatus === "success" || updateFAQStatus === "success" || deleteFAQStatus === "success")
                    && <ToastAlert message={t('alert.success_operation')} type={'success'} timeOut={5000} />}


                {(addFAQStatus === "error" || updateFAQStatus === "error" || deleteFAQStatus === "error")
                    && <ToastAlert message={t('alert.failed_operation')} type={'error'} timeOut={5000} />}


            </PageWrapper >

        </DashboardWrapper>

    );
}

export default FaqList;


